// ---Third-party imports
import {isString} from 'ldash'
import {createAction} from 'redux-actions'

// ---Framework imports
import log from 'uix/logging'
import {COPY2PAYLOAD, GENERATOR, SILENT} from 'uix/actions'

// ---Globals
export let dismissNotification = createAction('NOTIFICATION_DISMISS', id => ({id}))
// nobody runs cleanup actually
export let clearAllNotifications = createAction('NOTIFICATION_CLEAR')

const NotificationType = {
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}

let extractError = error => {
  let lines = []

  if (error.name == 'TimeoutError') {
    lines.push(`Timeout: ${parseInt(error.timeout / 1000)}s`)
  } else if (error.status) {
    lines.push(`${error.name} [${error.status}]`)
  }
  if (error.url) {
    lines.push(`url: ${error.url}`)
  }

  // extract traceback
  try {
    let cut = fn => (fn.includes('\\') ? fn.split('\\') : fn.split('/')).slice(-2).join('/')
    if (error.traceback) {
      lines = error.traceback.map(([filename, linenum, funcname, code]) => {
        return `File "${cut(filename)}", line ${linenum}, in ${funcname}\n  ${code}`
      })
    }
  } catch (e) {
    lines.push('traceback render failed')
  }

  return lines.join('\n')
}

let check_string_msg = action_constructor => data => {
  if (isString(data)) {
    data = {message: data}
  }
  return action_constructor(data)
}

export let errorNotification = createAction(
  'NOTIFICATION_ERROR',
  check_string_msg(({error, message, header, ...args}) => {
    let notifargs = {
      dismissAfter: 0,
      ...args,
      type: 'ERROR',
      header: header || 'Error',
      message: message,
    }
    if (error) {
      notifargs = {
        ...notifargs,
        message: [
          message,
          error.message,
          error.error && error.errorMsg
            ? `${error.error}: ${error.errorMsg}`
            : error.error || error.errorMsg,
        ]
          .filter(e => e)
          .join('\n'),
        details: extractError(error),
      }
    }
    return showNotification(notifargs).payload
  })
)

export let successNotification = createAction(
  'NOTIFICATION_SUCCESS',
  check_string_msg(
    ({header, ...args}) =>
      showNotification({
        ...args,
        type: 'SUCCESS',
        header: header || 'Info',
      }).payload
  )
)

export let warningNotification = createAction(
  'NOTIFICATION_WARN',
  check_string_msg(
    ({header, ...args}) =>
      showNotification({
        dismissAfter: 0,
        ...args,
        type: 'WARNING',
        header: header || 'Warning',
      }).payload
  )
)

export let showNotification = createAction('NOTIFICATION_SHOW', (options = {}) => {
  if (isString(options)) {
    options = {message: options}
  }
  let {message = ''} = options
  let {header = ''} = options
  let {details = ''} = options
  let {icon} = options
  let {position} = options
  let {color} = options
  let {type = NotificationType.INFO} = options
  let {dismissAfter = 2000} = options
  // in other cases, we push generated id's into action.meta
  let id = GENERATOR('notificationId')().notificationId
  return {message, header, color, type, icon, position, details, dismissAfter, id, visible: true}
})
